<template>
  <div>
    <el-header class="isResigters">
      <div class="Header RegisterPage">
        <div class="Globalcontainer">
          <img src="../assets/Home/组 23378@2x.png" alt />
          <div class="RightContent">
            <span style="cursor: pointer" @click="OpenLogin">登录</span>
            <el-button type="primary" @click="toRegister" size="small">注册</el-button>
            <h3 @click="BackIndex">返回首页</h3>
          </div>
        </div>
      </div>
    </el-header>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      isRegister: false,
    }
  },
  methods: {
    OpenLogin() {
      // console.log("333");
      this.$emit('toLogin')
    },
    toRegister() {
      this.$router.push('/Register')
    },
    BackIndex() {
      this.$router.replace('/Index')
    },
  },
}
</script>

<style lang='scss' scoped>
.RegisterPage {
  height: 26.375rem;
  background: url('../assets/images/Header.png');
  background-size: 100% 100%;
}
.el-header {
  padding: 0;
}
.isResigters {
  height: 26.375rem !important;
}
.Header {
  // background-image: url("../assets/Home/组 20@2x.png");
  // height: 8.75rem;
  // background-size: 100% 100%;
  div {
    padding-top: 1.875rem;
    img {
      width: 33.5625rem;
      height: auto;
    }

    /deep/ .el-input-group__append {
      background: #5599ff;
      color: #fff;
      border: 0.0625rem solid #5599ff;
    }
  }
}
.RightContent {
  display: flex;
  font-size: 0.9375rem;
  color: #fff;
  align-items: center;
  padding: 0 !important;
  h3 {
    margin-left: 3.125rem;

    font-size: 1.5rem !important;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #fff;
    display: inline-block;
    vertical-align: middle;
  }
  div {
    padding: 0;
  }
  span {
    width: 8.75rem;
    margin-left: 1.25rem;
    display: inline-block;
  }
  .el-button {
    background: transparent;
  }
}
</style>